<section class="resume portfolio-section zoom-gallery filter-section">
    <div class="container">
<!-- <app-portfolio-gallery class="p-4col-width" class="p-4col-width"></app-portfolio-gallery> -->
</div>
</section>